import { Ability } from '@casl/ability';
import CryptoJS from 'crypto-js';

const p = '2@%eGH[Qnad?#*P%#axHm1tlSre6Q8';
const w = 'NE8Lw]FLAZlST3*H2rGppQW13,Mp6q';

const saveLocalPermission = (value) => {
  localStorage.setItem(
    'p',
    CryptoJS.AES.encrypt(JSON.stringify(value), p + w).toString(),
  );
};

const getLocalPermission = () => {
  const data = localStorage.getItem('p');
  if (data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, p + w);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      decryptedData.push(addPermissionDefault());
      return decryptedData;
    } catch (e) {
      console.error('Erro ao descriptografar permissões', e);
      return [addPermissionDefault()]; // Fallback seguro
    }
  }

  return;
};

const getPermission = () => {
  const permission = getLocalPermission();
  redirectLogin(permission);
  return new Ability(permission);
};

const addPermissionDefault = () => {
  return { action: 'read', subject: 'Dashboard' };
};

const redirectLogin = (permission) => {
  if (!permission || permission.length === 0) {
    localStorage.removeItem('user-token');
  }
};

const actionsDefault = {
  Leitura: 'Leitura',
  Escrita: 'Escrita',
  Inativar: 'Inativar',
  Exportar: 'Exportar',
  Reativar: 'Reativar',
};

export default {
  getPermission,
  saveLocalPermission,
  actionsDefault,
};
